import { SC } from "./../helper/ServerCall";
import { pathSegment } from "../helper/queryString";

export const commentServices = {
    getCommentCategories,
    getAllComments,
    deleteComment,
    addComment,
    editComment,
    toggleCommentHighlight,
    getContactLogTypes,
    getCommentCategoryByTitle,
    getCommentsByColumn,
    updateOrderCsrStep,
    getContent,
    getLatestCommentByCategoryTitle,
    addSMS,
    getAllSMS
}

function getCommentCategories() {
    return SC.getCall('getCommentCategory');
}

function getAllComments(page, filter, sort, pageSize, cat_id, modelId, from, to, uuid) {
    return SC.getCall(`comments/${pathSegment(cat_id)}/${pathSegment(modelId)}`, {
        page,
        filter,
        pageSize,
        sort,
        from,
        to,
        uuid,
    });
}

function deleteComment(id) {
    return SC.deleteCall(`comments/${pathSegment(id)}`);
}

function addComment(data, modelId) {
    return SC.postCall(`comments/${pathSegment(modelId)}`, data);
}

function editComment(data, id) {
    return SC.putCall(`comments/${pathSegment(id)}`, data);
}

function toggleCommentHighlight(id) {
    return SC.putCall(`toggleCommentHighlgiht/${pathSegment(id)}`, []);
}

function getCommentCategoryByTitle(titles) {
    return SC.postCall(`getCommentCategoryByTitle`, { titles: titles });
}

function getContactLogTypes(orderId) {
    return SC.getCall(`getContactLogTypes/${pathSegment(orderId)}`);
}

function getCommentsByColumn(data) {
    return SC.postCall('getCommentsByColumn', data);
}
function updateOrderCsrStep(modelId, data) {
    return SC.putCall(`updateOrderCsrStep/${pathSegment(modelId)}`, data);
}
function getContent(account_id, order_id, code) {
    return SC.getCall('csrTemplate', { code, account_id, order_id });
}

function getLatestCommentByCategoryTitle(title, model_id) {
    return SC.getCall('getLatestCommentByCategoryTitle', { title, model_id });
}

function addSMS(data, orderId) {
    return SC.postCall(`sms_messages/${pathSegment(orderId)}`, data);
}

function getAllSMS(orderId) {
    return SC.getCall(`sms_messages/${pathSegment(orderId)}`);
}
